import React, { Fragment, useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input,Row, Col } from "reactstrap";
import { TimePicker } from "react-time-picker";
import Select from "react-select";
import MenuItem from "react-select";
import { render } from "@testing-library/react";
import "../../../style/calendarclass.css";
import moment from "moment";
import { Table, Checkbox } from "semantic-ui-react";
const FormFieldConfigureMail = React.memo((props) => {
  const { inputFields, formValidation ,intimeval,outtimeval,halfdayworkval,fulldayworkval} = props;
  const [inputFieldsArr, setInputFieldsArr] = useState(null);
const[desoptions , setOptions] =useState([{}]);
let options=[];
   inputFields.map(function (desig) {
    if(desig.type=="multipleselect" && desig.option.length >0)
    {
      desig.option.map((el,i) =>{
       options.push({value: el.designationId, label: el.designationName }); 
      })
     
    }
       
  })

  let intim=moment(intimeval, "hhmma").format("HH:mm");
  let outtim=moment(outtimeval, "hhmma").format("HH:mm");
// const options = [
//   { value: "Spring", label: "Spring" },
//   { value: "Summer", label: "Summer" },
//   { value: "Autumn", label: "Autumn" },
//   { value: "Winter", label: "Winter" }
// ];

  return (
    <div>
    <Fragment>
    <Form>

              <FormGroup>
               
                    <FormGroup>
                 <Label>Location : </Label>
                <Label>{props.formData.val.address}</Label></FormGroup>
             
                <FormGroup> <Label>Department : </Label>
                  <Label>{props.formData.val.departmentName}</Label></FormGroup>

                  <FormGroup>  <Label>Request Type : </Label>
                  <Label>{props.formData.val.requestType}</Label></FormGroup>

                  <FormGroup>  <Label>Calendar Year : </Label>
                  <Label>{props.formData.val.description}</Label></FormGroup>
               

                
               
                {/* {Object.keys(formValidation)?.length !== 0 &&
                  !formValidation?.[val.name]?.isValid && (
                    <span className=" " style={{ color: "red" }}>
                      {formValidation?.[val.name]?.errorMessage}
                    </span>
                  )} */}
              </FormGroup>
              <Row form >
              <Col md={12} className="radio">
              <Label check >
                  <Input type="radio"  name="radio1" /> Department
                </Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Label check >
                  <Input type="radio"  name="radio1" /> Employee
                </Label>
                </Col>
              </Row>
              <Row form>
          <Col md={4}>
              <Table>

      <Table.Body>

      <Table.Row>
                <Table.Cell>
          <input type="checkBox" 
          /> <Label>To</Label>
        </Table.Cell>
        </Table.Row>
        <Table.Row>
        <Table.Cell>
          <input type="checkBox"
          /> <Label>BCC</Label>
        </Table.Cell>
        </Table.Row>
        <Table.Row>
        <Table.Cell>
          <input type="checkBox"
          /> <Label>CC</Label>
        </Table.Cell>
        </Table.Row>

      </Table.Body>
    </Table>
    </Col>
    <Col md={8}>
    </Col>
    </Row>
    </Form>
    </Fragment>
    </div>
  );
});

export default FormFieldConfigureMail;
